import { render, staticRenderFns } from "./dialogInfo.vue?vue&type=template&id=10e6317e&scoped=true&"
import script from "./dialogInfo.vue?vue&type=script&lang=js&"
export * from "./dialogInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogInfo.vue?vue&type=style&index=0&id=10e6317e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e6317e",
  null
  
)

export default component.exports